import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from "react-i18next";

const AlertDialogComponent = ({
  open,
  onClose,
  title,
  text,
  text2,
  onConfirm,
  hideCancelBtn,
  subtitle,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {title && <DialogTitle id="alert-dialog-title">{title}</DialogTitle>}
      {subtitle && (
        <DialogTitle id="alert-dialog-subtitle">
          <Typography variant="subtitle-1">{subtitle}</Typography>
        </DialogTitle>
      )}
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {text}
        </DialogContentText>
        {text2 && (
          <DialogContentText marginTop={1} id="alert-dialog-description2">
            {text2}
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        {!hideCancelBtn && (
          <Button onClick={onClose}>{t("alertDialog.cancel")}</Button>
        )}
        <Button onClick={onConfirm} autoFocus>
          {t(hideCancelBtn ? "alertDialog.ok" : "alertDialog.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default AlertDialogComponent;
